import React, { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import TopCategoryOuter from "../TopCategoryOuter"

import { SyakenTenkenMenkyoGrid } from "./SyakenTenkenMenkyoGrid"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import ComboBox from "../../../components/ComboBox"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import BusyoService from "../../../service/master/busyo/busyoService"
import { T車検点検免許 } from "../../../service/dashboard/TDashboard"
import DashboardService from "../../../service/dashboard/dashboardService"
import { Button } from "react-bootstrap"

/**
 * 車検点検免許更新情報
 * @returns
 */
const SyakenTenkenMenkyoList = () => {
  const [searchStart, setSearchStart] = useState(false)
  const [車検点検免許更新List, set車検点検免許更新List] =
    useState<T車検点検免許[]>()

  const [comboBoxDataInitialized, setComboBoxDataInitialized] = useState(false)
  const loginUserInfo = useSelector(
    (state: RootState) => state.user.LoginUserInfo
  )

  const [車検情報表示フラグ, set車検情報表示フラグ] = useState(true)
  const [点検情報表示フラグ, set点検情報表示フラグ] = useState(true)
  const [免許情報表示フラグ, set免許情報表示フラグ] = useState(true)

  // 部所
  const [部所コード, set部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  const searchFunction = useCallback(async () => {
    const 部所売上額Res =
      await new DashboardService().getSyakenTenkenMenkyoList({})
    set車検点検免許更新List(部所売上額Res?.data)
    setSearchStart(false)
  }, [])

  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      setComboBoxDataInitialized(true)
    })
  }, [])

  useEffect(() => {
    if (!comboBoxDataInitialized || !部所ComboBox) return
    if (loginUserInfo.運行部所フラグ === 1) {
      set部所コード(loginUserInfo.部所コード)
    }
    setSearchStart(true)
  }, [comboBoxDataInitialized, loginUserInfo, 部所ComboBox])

  return (
    <div>
      <div className="w-100 mb-2">
        <div className={"w-13rem text-end d-inline-block"}>
          <ComboBox.Busyo
            placeholder="部所"
            isDisabled={searchStart}
            isLoadEnded={部所isLoadEnded}
            setIsLoadEnded={set部所isLoadEnded}
            isAllSelect={true}
            isRequired={true}
            itemsSource={部所ItemSource}
            selectedValue={部所コード}
            // 1050:車輌部と1080:共有車輌を追加
            listFilter={(d) =>
              d.運行部所フラグ === 1 || ["1050", "1080"].includes(d.部所コード)
            }
            setSelectedValue={(v) => {
              set部所コード(v)
            }}
            ComboBox={部所ComboBox}
            setComboBox={set部所ComboBox}></ComboBox.Busyo>
        </div>
        <div
          className="ms-2 d-inline-block"
          style={{
            alignItems: "center",
            marginBlock: "auto",
            height: "100%",
          }}>
          <Button
            type="button"
            variant={車検情報表示フラグ ? "danger" : "outline-danger"}
            disabled={searchStart}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              set車検情報表示フラグ(!車検情報表示フラグ)
            }}>
            車検
          </Button>
        </div>
        <div
          className="ms-2 d-inline-block"
          style={{
            alignItems: "center",
            marginBlock: "auto",
            height: "100%",
          }}>
          <Button
            type="button"
            variant={点検情報表示フラグ ? "primary" : "outline-primary"}
            disabled={searchStart}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              set点検情報表示フラグ(!点検情報表示フラグ)
            }}>
            点検
          </Button>
        </div>
        <div
          className="ms-2 d-inline-block"
          style={{
            alignItems: "center",
            marginBlock: "auto",
            height: "100%",
          }}>
          <Button
            type="button"
            variant={免許情報表示フラグ ? "success" : "outline-success"}
            disabled={searchStart}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              set免許情報表示フラグ(!免許情報表示フラグ)
            }}>
            免許
          </Button>
        </div>
      </div>
      <TopCategoryOuter
        searchFunction={searchFunction}
        searchStartFlag={searchStart}>
        <SyakenTenkenMenkyoGrid
          busyoCode={部所コード}
          syakenFlag={車検情報表示フラグ}
          tenkenFlag={点検情報表示フラグ}
          menkyoFlag={免許情報表示フラグ}
          syakenTenkenMenkyoList={
            車検点検免許更新List
          }></SyakenTenkenMenkyoGrid>
      </TopCategoryOuter>
    </div>
  )
}

export default SyakenTenkenMenkyoList
